import { Tag, TagProps, TagLabel } from "@chakra-ui/react"
import { ErrorIcon, ErrorAlertIcon } from "components/ErrorIcon"
import { SuccessIcon } from "components/SuccessIcon"

export type Status = "ERROR" | "SUCCESS"

interface StatusBadgeProps extends TagProps {
  errorCount?: number
  size?: "sm" | "md" | "lg"
  status: Status
}

export const StatusBadge = ({
  errorCount,
  size = "md",
  status,
  ...rest
}: StatusBadgeProps) => {
  const hasErrors = status === "ERROR"
  const hasErrorCount = !!errorCount
  const iconProps = { boxSize: 4 }

  const getMinSize = (size: string) => {
    switch (size) {
      case "sm":
        return "13px"
      case "lg":
        return 8
      case "md":
      default:
        return 6 // default to md size
    }
  }
  const minSize = getMinSize(size)

  return (
    <Tag
      backgroundColor={hasErrors ? "error" : "success"}
      borderRadius="full"
      boxShadow="01"
      color="white"
      fontFamily="body"
      fontSize="xs"
      fontWeight="bold"
      justifyContent={hasErrorCount ? undefined : "center"}
      letterSpacing="wide"
      lineHeight="1.33"
      minHeight={minSize as any}
      minWidth={minSize as any}
      paddingX={hasErrorCount ? 2 : 0}
      size={size}
      {...rest}
    >
      {hasErrors ? (
        hasErrorCount ? (
          <>
            <ErrorIcon {...iconProps} />
            <TagLabel marginLeft="5px">
              {errorCount} {errorCount !== 1 ? "errors" : "error"}
            </TagLabel>
          </>
        ) : (
          <ErrorAlertIcon {...iconProps} />
        )
      ) : (
        <SuccessIcon {...iconProps} />
      )}
    </Tag>
  )
}
